import { Observable, throwError } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MaintenanceInterface } from '@app/interfaces/_index';
import { getCacheBustedParams } from '@app/utilities/_index';
import { environment } from '@environments/environment';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from '../shared/error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService extends ErrorHandlerService {
  private baseUrl = `${environment.cms.url}/wp-json/wp/v2`;
  private maintenanceUrl = `${this.baseUrl}/notification`;
  private errorUrl = `${this.baseUrl}/error_notification`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Return Maintenance for given customUrl, or falls back to default maintainence url.
   */
  getMaintenance(customUrl?: string): Observable<MaintenanceInterface> {
    const maintenanceParams = getCacheBustedParams();
    return this.http
      .get(`${customUrl ? customUrl : this.maintenanceUrl}`, { params: maintenanceParams })
      .pipe(
        catchError((err) => {
          console.log(`Service error has occurred`, err);
          return throwError(() => new Error(err));
        }),
        catchError(this.handleError<MaintenanceInterface>('getMaintenance'))
      );
  }
}
